var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCheckCircleP5028Px = function SvgIcCheckCircleP5028Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.383 20.777c-.375 0-.695-.166-.961-.5l-4.047-5.062a1.379 1.379 0 0 1-.219-.352 1.021 1.021 0 0 1-.062-.351.91.91 0 0 1 .265-.672.947.947 0 0 1 .688-.266c.318 0 .586.143.805.43l3.5 4.492 6.78-10.773c.12-.183.243-.31.368-.383a.902.902 0 0 1 .484-.117c.271 0 .493.086.664.257.172.167.258.386.258.657 0 .11-.018.221-.054.336-.037.109-.094.226-.172.351L13.336 20.27c-.23.338-.547.507-.953.507Z",
    fill: "#03D0E2"
  })));
};
export default SvgIcCheckCircleP5028Px;